<template>
  <div class="component-wrapper secondary d-flex flex-column">
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center flex-grow-1"
      style="height: 500px"
    >
      <v-progress-circular indeterminate color="primary lighten-1" size="60">
      </v-progress-circular>
    </div>

    <div
      class="d-flex align-center justify-center flex-row flex-wrap px-1 mt-4"
      style="padding-bottom: 64px"
      v-else-if="!loader && pois.length > 0"
    >
      <v-card
        class="white mb-4"
        width="300"
        min-height="200"
        v-for="(poi, i) in pois"
        :key="i"
        @click="$router.push(`/pois/${poi.id}`)"
      >
        <div style="position: relative">
          <v-img
            :aspect-ratio="1 / 1"
            height="150"
            cover
            :src="`https://efales.mobics.gr/${poi.main_image}`"
          ></v-img>
        </div>

        <div class="body-1 px-2 pt-2 mb-1 secondary--text font-weight-bold">
          {{ poi.name }}
        </div>
        <!-- <div class="body-2 px-2 pb-2 secondary--text">
          {{
            decodeEntities(poi.description).length > 30
              ? decodeEntities(poi.description).substring(0, 30) + "..."
              : decodeEntities(poi.description)
          }}
        </div> -->
      </v-card>
    </div>

    <v-bottom-sheet v-model="sheet" inset style="position: relative" scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="filters_button" color="primary" fab dark medium>
          <v-icon color="secondary" v-bind="attrs" v-on="on"
            >mdi-tune-vertical</v-icon
          >
        </v-btn>
      </template>

      <v-card color="white" height="auto" class="px-6 pb-16">
        <div class="text-h5 font-weight-bold pt-6">
          {{ $t("general.categories_label") }}
        </div>
        <v-divider class="my-4"></v-divider>
        <div
          v-for="(category, i) in categories"
          :key="i + category.id"
          @click="filterApply(category)"
          class="mb-4"
        >
          <span
            :class="
              filters.category && filters.category == category.id
                ? 'font-weight-bold'
                : 'font-weight-regular'
            "
            class="body-1 d-flex align-center"
          >
            <span class="mr-auto">
              {{ category.name }}
            </span>
            <v-icon
              v-if="filters.category && filters.category == category.id"
              color="brick"
            >
              mdi-check
            </v-icon>
          </span>
        </div>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>
  
<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { decodeEntities } from "../../utils/decodeEntities";

export default {
  async created() {
    this.setFilters({
      category: null,
    });
    try {
      const categories = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/categories`
      );

      const pois = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
        params: {
          area: this.filters.island,
          category: this.filters.category != 17 ? this.filters.category : null,
        },
      });

      this.categories = categories.data;

      this.pois = pois.data;

      this.loader = false;
      //todo -> add category query param
    } catch (e) {
      this.loader = false;
      console.log(e);
    }
  },

  data() {
    return {
      showFilters: false,
      loader: true,
      pois: [],
      sheet: false,

      categories: [],
    };
  },

  computed: {
    filters: {
      get() {
        return this.$store.state.base.filters;
      },
      set(newValue) {
        this.setFilters(newValue);
      },
    },
  },

  methods: {
    ...mapMutations(["setFilters"]),

    decodeEntities(text) {
      return decodeEntities(text);
    },

    async filterApply(category) {
      try {
        this.loader = true;
        this.filters.category = category.id;

        this.pois = [];
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
          params: {
            category: this.filters.category,
          },
        });
        this.pois = res.data;
        this.loader = false;
        this.sheet = false;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
  
  <style scoped lang="scss">
.filters_button {
  position: fixed;
  bottom: 40px;
  right: 30px;
}
</style>